import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Toaster } from '@/components/ui/toast';
import { createQueryClient } from '@/lib/query-client';

// Side-effect import: initialises i18next before any component calls `t`.
import '@/i18n';

export interface AppProvidersProps {
  children: ReactNode;
  /** Tests inject a client with retries off; the app creates its own. */
  queryClient?: QueryClient;
}

/**
 * Every cross-cutting provider, in one place (05 §5.2 `main.tsx`). The router is
 * deliberately NOT here so tests can mount the app under a `MemoryRouter`.
 */
export function AppProviders({ children, queryClient }: AppProvidersProps) {
  const [client] = useState(() => queryClient ?? createQueryClient());

  return (
    <QueryClientProvider client={client}>
      {children}
      <ToasterWithLocale />
    </QueryClientProvider>
  );
}

function ToasterWithLocale() {
  const { t } = useTranslation();
  return <Toaster closeLabel={t('common.close')} />;
}
